import React, { ReactNode } from "react";
import { EvaluationStatus, getEvaluationIcon } from "../evaluateQuestionnaireDialog/EvaluateQuestionnaireDialog.types";
import { Box } from "@mui/material";
import { useTranslation } from "../../../../localization/useTranslation";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";

export interface IQuestionnaireEvaluation {
    evaluationStatus: EvaluationStatus | undefined;
    evaluation: ReactNode | undefined;
}

function QuestionnaireEvaluation(props: IQuestionnaireEvaluation) {
    const { translateEvaluationEnum } = useTranslation();

    function getContent() {
        if (props.evaluationStatus) {
            const content = (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, marginTop: 0.3 }}>
                    <Box
                        sx={{
                            "& svg": {
                                display: "block",
                                width: 20,
                                height: 20,
                            },
                        }}
                    >
                        {getEvaluationIcon(props.evaluationStatus!)}
                    </Box>
                    <Box>{translateEvaluationEnum(props.evaluationStatus.toString())}</Box>
                </Box>
            );

            if (props.evaluation) {
                return <DotLegalTooltip text={props.evaluation}>{content}</DotLegalTooltip>;
            }

            return content;
        }

        return <div></div>;
    }

    return getContent();
}

export default QuestionnaireEvaluation;
